import React, { useState, useContext } from "react";
import "./AddContent.css";
import Collapsible from "../Collapsible/Collapsible";
import { BiCloudUpload } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFiletypePdf, BsFiletypeTxt } from "react-icons/bs";
import { toast } from "react-toastify";

import { BeatLoading, HashLoading } from "../Spinner/Spinners";
import { GlobalStateContext } from "../../GlobalStateProvider";

const AddContent = () => {
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [textContent, setTextContent] = useState("");
  const [type, setType] = useState(null);
  const { index, indexType } = useContext(GlobalStateContext);
  const [collapse, setCollapse] = useState({
    files: true,
    text: false,
    url: false,
  });
  const [setTimeoutReached] = useState(false);
  const [timeoutDuration] = useState(60000);
  const backend_url =
    indexType === "excel"
      ? process.env.REACT_APP_EXCEL_URL
      : process.env.REACT_APP_BACKEND_URL;

  const handleCollapse = (id) => {
    // console.log("collapse", collapse);
    setCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((accumulator, key) => {
        accumulator[key] = key === id ? !prevState[key] : false;
        return accumulator;
      }, {}),
    }));
    setContent(null);
    setLoaded(false);
  };

  const handleselectedFile = (event) => {
    try {
      setContent(event.target.files[0]);
      setType("files");
      // console.log("type", type);
      setLoaded(true);
    } catch (error) {}
  };
  const handleselectedText = (event) => {
    try {
      setContent(event.target.value);
      setTextContent(event.target.value);
      setType("text");
      setLoaded(true);
    } catch (error) {}
  };
  const handleselectedURL = (event) => {
    try {
      setContent(event.target.value);
      setTextContent(event.target.value);
      setType("url");
      setLoaded(true);
    } catch (error) {}
  };

  const handleDisabled = () => {
    if (loaded) return false;
    else return true;
  };

  const formatFileSize = (bytes) => {
    const sufixes = ["B", "kB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sufixes[i]}`;
  };

  const handleUpload = () => {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    if (!content) {
      toast.warning("Please select a file to upload");
      return;
    }
    const formData = new FormData();
    if (type === "files" || type === "text" || type === "url") {
      formData.append(type, content);
      setContent(null);
    } else {
      setContent(null);
      return;
    }
    setLoaded(false);
    setTextContent("");
    formData.append("index", index);

    // Show the first stage: Uploading
    const toastId = toast(
      <div
        style={{
          display: "flex",
          gap: 10,
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <BeatLoading /> Uploading your file...
      </div>,
      { autoClose: false }
    );

    // Create a function to update the toast message with a delay
    const updateToastWithDelay = (message, delayMs) => {
      return delay(delayMs).then(() => {
        toast.update(toastId, {
          render: (
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                justifyContent: "left",
              }}
            >
              <HashLoading />
              {message}
            </div>
          ),
          autoClose: false,
        });
      });
    };

    const stage1Promise = updateToastWithDelay("Extracting Data...", 3000);
    const stage2Promise = stage1Promise.then(() =>
      updateToastWithDelay("Embedding Data...", 5000)
    );
    setTimeout(() => {
      setTimeoutReached(true);
      // console.log(
      //
      // );
      toast.update(toastId, {
        render: (
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            {/* <HashLoading /> */}
            Embedding is taking longer than expected. Please wait or continue
            chatting, it may still complete.
          </div>
        ),
        type: toast.TYPE.WARNING,
        autoClose: false,
      });
    }, timeoutDuration);
    // console.log("formData", formData.files);
    const uploadPromise = fetch(backend_url + "/api/AddContent", {
      method: "POST",
      mode: "cors",
      body: formData,
    }).then((response) => {
      if (response.ok) return response.text();
      else throw new Error("Embedding failed");
    });

    // Wait for both the last stage and the API call to be completed
    Promise.all([stage2Promise, uploadPromise])
      .then(([_, data]) => {
        // Show the success message
        toast.update(toastId, {
          render: `Success: ${data}`,
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
        });
      })
      .catch((error) => {
        // Show the error message
        // toast.dismiss();
        toast.update(toastId, {
          render: `${error}`,
          type: toast.TYPE.ERROR,
          autoClose: 5000,
        });
      });
  };

  return (
    <div className="DocAdd">
      <div className="content-heading">
        <p>Add Content</p>
        {/* <BarLoading /> */}
      </div>
      {indexType === "excel" ? (
        <>
          <div className="collapsible-container">
            <p className="desc">
              Select a .csv/.xls(x) file and click on compute to add it to the{" "}
              {index}.
            </p>
            <p className="desc" style={{ color: "red" }}>
              Please make sure the data is in tabular format and doesnot contain
              any images/graphs or any media in general.
            </p>
            <label className="drop-container">
              <span className="info-container">
                <BiCloudUpload size={50} />
                <span className="input-desc">
                  <p>Click to Browse</p>
                  <p>csv, XLS(X) </p>
                </span>
                <input
                  type="file"
                  accept=".csv, .xls, .xlsx"
                  name="file"
                  onChange={handleselectedFile}
                  hidden
                />
              </span>
              <button
                onClick={handleUpload}
                disabled={handleDisabled()}
                className="uploadSubmit"
              >
                Compute
              </button>
            </label>
            {loaded && (
              <div className="file-container">
                <span className="file-info">
                  {content.type === "application/pdf" ? (
                    <BsFiletypePdf size={25} />
                  ) : (
                    <BsFiletypeTxt size={25} />
                  )}
                  {content.name} &#x2022; {formatFileSize(content.size)}
                </span>
                <button
                  onClick={() => {
                    setContent(null);
                    setLoaded(false);
                  }}
                >
                  <AiOutlineCloseCircle size={20} />
                </button>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <Collapsible
            className="collapsible"
            isOpen={collapse.files}
            handleCollapse={() => handleCollapse("files")}
            title={`Add Document to the ${index}`}
          >
            <div className="collapsible-container">
              <p className="desc">
                Select a document and click on compute to add it to the {index}.
              </p>
              <label className="drop-container">
                <span className="info-container">
                  <BiCloudUpload size={50} />
                  <span className="input-desc">
                    <p>Click to Browse</p>
                    <p>PDF, TXT, PNG, JPEG, PPT(X), XLS(X), DOC(X) </p>
                  </span>
                  <input
                    type="file"
                    accept="text/plain, application/pdf, image/png, image/jpeg, .doc,.docx,.ppt, .pptx, .xls, .xlsx"
                    name="file"
                    onChange={handleselectedFile}
                    hidden
                  />
                </span>
                <button
                  onClick={handleUpload}
                  disabled={handleDisabled()}
                  className="uploadSubmit"
                >
                  Compute
                </button>
              </label>
              {loaded && (
                <div className="file-container">
                  <span className="file-info">
                    {content.type === "application/pdf" ? (
                      <BsFiletypePdf size={25} />
                    ) : (
                      <BsFiletypeTxt size={25} />
                    )}
                    {content.name} &#x2022; {formatFileSize(content.size)}
                  </span>
                  <button
                    onClick={() => {
                      setContent(null);
                      setLoaded(false);
                    }}
                  >
                    <AiOutlineCloseCircle size={20} />
                  </button>
                </div>
              )}
            </div>
          </Collapsible>

          <Collapsible
            className="collapsible"
            isOpen={collapse.text}
            handleCollapse={() => handleCollapse("text")}
            title={`Add text to ${index}`}
          >
            <div className="collapsible-container">
              <p className="desc">
                Add a new text content and then click on 'Compute'
              </p>
              <span className="input-container">
                <textarea
                  className="textarea"
                  placeholder="Place your text here"
                  onChange={handleselectedText}
                  value={textContent}
                />
                <button
                  className="uploadSubmit"
                  disabled={textContent === "" ? true : false}
                  onClick={handleUpload}
                >
                  Compute
                </button>
              </span>
            </div>
          </Collapsible>
          <Collapsible
            className="collapsible"
            isOpen={collapse.url}
            handleCollapse={() => handleCollapse("url")}
            title={`Add URLs to the ${index}`}
          >
            <div className="collapsible-container">
              <p className="desc">Add URLs and then click on 'Compute'</p>
              <span className="input-container">
                <textarea
                  className="textarea"
                  placeholder="Place your URLs here seperated by a new line"
                  onChange={handleselectedURL}
                  value={textContent}
                />
                <button
                  className="uploadSubmit"
                  disabled={textContent === "" ? true : false}
                  onClick={handleUpload}
                >
                  Compute
                </button>
              </span>
            </div>
          </Collapsible>
        </>
      )}
    </div>
  );
};

export default AddContent;
